import { useGetAllBaseTariffParameter } from '@/hooks/data/masterDataHook';
import { Select, SelectProps } from 'antd';
import React from 'react';

interface Props extends SelectProps<any> {
  category?: number | null | undefined;
}
export default function BaseTariffParameterInput({ category, ...props }: Props) {
  const { data, isLoading } = useGetAllBaseTariffParameter();

  let options = React.useMemo(() => {
    if (category) {
      return data?.filter(x => x.category === category) || [];
    }
    return data;
  }, [data, category]);
  return (
    <Select
      maxTagCount="responsive"
      allowClear
      loading={isLoading}
      {...props}
      filterOption={(input, option) => {
        return (option?.children as any)?.toLowerCase().includes(input.toLowerCase());
      }}
      showSearch={true}
    >
      {options?.map(c => {
        return (
          <Select.Option key={c.id} value={c.id}>
            {`${c.name}`}
          </Select.Option>
        );
      })}
    </Select>
  );
}
